/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilitySettings } from './FacilitySettings';
import {
    FacilitySettingsFromJSON,
    FacilitySettingsFromJSONTyped,
    FacilitySettingsToJSON,
} from './FacilitySettings';

/**
 * 
 * @export
 * @interface GetFacilitySettings200Response
 */
export interface GetFacilitySettings200Response {
    /**
     * 
     * @type {FacilitySettings}
     * @memberof GetFacilitySettings200Response
     */
    data?: FacilitySettings;
}

/**
 * Check if a given object implements the GetFacilitySettings200Response interface.
 */
export function instanceOfGetFacilitySettings200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetFacilitySettings200ResponseFromJSON(json: any): GetFacilitySettings200Response {
    return GetFacilitySettings200ResponseFromJSONTyped(json, false);
}

export function GetFacilitySettings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFacilitySettings200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FacilitySettingsFromJSON(json['data']),
    };
}

export function GetFacilitySettings200ResponseToJSON(value?: GetFacilitySettings200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FacilitySettingsToJSON(value.data),
    };
}

